import { render, staticRenderFns } from "./yuetuzhuang.vue?vue&type=template&id=111608b6&scoped=true&"
import script from "./yuetuzhuang.vue?vue&type=script&lang=js&"
export * from "./yuetuzhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111608b6",
  null
  
)

export default component.exports